import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { SellerAvatar, type SellerAvatarProps } from './SellerAvatar';

type SellerAvatarResponsiveProps = Omit<SellerAvatarProps, 'size'> & {
  forceLarge?: boolean;
};
export function SellerAvatarResponsive({ forceLarge = false, ...props }: SellerAvatarResponsiveProps) {
  if (forceLarge) {
    return <SellerAvatar size="lg" {...props} />;
  }

  return (
    <>
      <Container hidden={{ md: true }}>
        <SellerAvatar size="md" {...props} />
      </Container>
      <Container hidden={{ default: true, md: false }}>
        <SellerAvatar size="lg" {...props} />
      </Container>
    </>
  );
}
